import React, { Component } from 'react'
import { BadgeGate } from '../../common/permissions/badgeGate'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'

export interface Props {
  userId: string
  isDropdownActive: boolean
}

export class AdminBannerDropdown extends Component<Props> {
  static displayName = 'AdminBannerDropdown'

  render() {
    const { userId, isDropdownActive } = this.props

    return (
      <div
        className={classnames('user-banner__dropdown', {
          'user-banner__dropdown--hidden': !isDropdownActive,
        })}
      >
        <h4 className="user-banner__dropdown-header">MANAGE ADMIN</h4>
        <BadgeGate disableUI requiredBadges={['ADMIN']}>
          <NavLink
            data-testid="admin-banner-dropdown-link"
            className="user-banner__dropdown-link"
            to={`/admins/${userId}/edit`}
          >
            Edit Admin Profile
          </NavLink>
        </BadgeGate>
      </div>
    )
  }
}
